const {
    _generateAESCredentials,
    _formAESKeystore,
    _validateBLSKeystore,
    _unlockAESPrivateKey,
    _unlockBLSKeystore,
    _formCIPCiphertext,
    _isReEncryptionCompleted,
    _reEncrypt,
    _applyForDecryption,
    _getRequestAvailabilityBlock,
    _getPartialDecryptionPieces,
    _getAllGuardians,
    _getThreshold,
    _getAESPublicKeyfromPrivateKey,
    _aggregateSharedPrivateKeys,
    _formBLSKeystore,
    _getDecryptionState,
    _getSafeBox,
    _decryptionEligibilityChecks,
} = require('../logic/cip');

class CipSubPackage {

    constructor(signer) {
        this.etherSigner = signer;
    }

    generateAESCredentials() {
        return _generateAESCredentials();
    }

    formAESKeystore(aesPrivateKey, password) {
        return _formAESKeystore(aesPrivateKey, password);
    }
    
    validateBLSKeystore(keystore, password, blsPublicKey) {
        return _validateBLSKeystore(keystore, password, blsPublicKey);
    }

    unlockAESPrivateKey(keystore, password, blsPublicKey) {
        return _unlockAESPrivateKey(this.etherSigner, keystore, password, blsPublicKey);
    }
    
    unlockBLSKeystore(keystore, password) {
        return _unlockBLSKeystore(keystore, password);
    }
    
    formCIPCiphertext(blsPrivateKey) {
        return _formCIPCiphertext(this.etherSigner, blsPrivateKey);
    }
    
    isReEncryptionCompleted(blsPublicKey) {
        return _isReEncryptionCompleted(this.etherSigner, blsPublicKey);
    }
    
    reEncrypt(blsPublicKey, stakehouseAddress, blsKeystore, blsKeystorePassword) {
        return _reEncrypt(this.etherSigner, blsPublicKey, stakehouseAddress, blsKeystore, blsKeystorePassword);
    }
    
    applyForDecryption(blsPublicKey, stakehouseAddress, aesPublicKey) {
        return _applyForDecryption(this.etherSigner, blsPublicKey, stakehouseAddress, aesPublicKey);
    }
    
    getRequestAvailabilityBlock(blsPublicKey) {
        return _getRequestAvailabilityBlock(this.etherSigner, blsPublicKey);
    }
    
    getPartialDecryptionPieces(blsPublicKey, aesPublicKey) {
        return _getPartialDecryptionPieces(this.etherSigner, blsPublicKey, aesPublicKey);
    }
    
    getAllGuardians() {
        return _getAllGuardians(this.etherSigner);
    }
    
    getThreshold() {
        return _getThreshold(this.etherSigner);
    }
    
    getAESPublicKeyfromPrivateKey(aesPrivateKey) {
        return _getAESPublicKeyfromPrivateKey(aesPrivateKey);
    }
    
    aggregateSharedPrivateKeys(aesPrivateKey, blsPublicKey) {
        return _aggregateSharedPrivateKeys(this.etherSigner, aesPrivateKey, blsPublicKey);
    }
    
    formBLSKeystore(blsSigningKey, password) {
        return _formBLSKeystore(blsSigningKey, password);
    }
    
    getDecryptionState(blsPublicKey) {
        return _getDecryptionState(this.etherSigner, blsPublicKey);
    }

    getSafeBox() {
        return _getSafeBox(this.etherSigner);
    }

    decryptionEligibilityChecks(blsPublicKey, stakehouseAddress=null, safeBox=null) {
        return _decryptionEligibilityChecks(this.etherSigner, blsPublicKey, stakehouseAddress, safeBox);
    }
}

module.exports = {
    CipSubPackage
};
